import styles from "../rankings.module.scss";

export function ElideCell({ getValue }) {
    return <Elide title={getValue()}>{getValue()}</Elide>;
}
export function Elide(props) {
    return <div {...props} className={styles.elide} />;
}
